/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XAddress from "vux/src/components/x-address/index.vue";
import ChinaAddressV4Data from '@/assets/china_address.json';
export default {
  components: {
    XAddress: XAddress
  },
  props: {
    title: {
      type: String,
      default: '地址选择'
    },
    value: {
      type: Array
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data: function data() {
    return {
      ChinaAddressV4Data: ChinaAddressV4Data,
      ids: [],
      names: [],
      currValue: this.value,
      hasTitleSlot: false,
      hasInit: true
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.currValue)) {
          this.currValue = this.value;
        }
      },
      immediate: true
    },
    currValue: {
      handler: function handler(val) {
        this.$emit('on-change', this.ids.slice(0), this.names.slice(0));
        this.$emit('input', val);
      }
    }
  },
  methods: {
    onShadowChange: function onShadowChange(ids, names) {
      this.ids = ids;
      this.names = names; // 初始化 触发on-change

      if (this.hasInit) {
        this.$emit('on-change', this.ids.slice(0), this.names.slice(0));
        this.hasInit = false;
      }
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};